const { Application } = Shopware;

Application.addServiceProviderDecorator('searchTypeService', (searchTypeService) => {
    searchTypeService.upsertType('tdcl_customer_contact', {
        entityName: 'tdcl_customer_contact',
        placeholderSnippet: 'TopdataContactLoginSW6.contactList.list.placeholderSearchBar',
        listingRoute: 'topdata.contact.login.list',
        hideOnGlobalSearchBar: true,
    });

    return searchTypeService;
});
